// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__25WlR","consentsList":"PatientConsents_consentsList__7aFqg","consentsListEmpty":"PatientConsents_consentsListEmpty__3atJE"};